module.exports = __webpack_public_path__ + "static/512x512-a3cbfd3222e4a493a964a6a8062c741d.png";